export function PdfPreview(props: { url: string; }) {
    return (
        <iframe title="PDF-Preview"
            src={props.url + "#toolbar=0&navpanes=0&scrollbar=0"}
            // type="application/pdf"
            width="100%"
            height="100%"
        ></iframe>
    );
}
